import { Component, OnInit, Input } from '@angular/core';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { IPicture } from '@finder/shared/components/picture/picture.interface';

@Component({
    selector: 'finder-featured-menu-items',
    templateUrl: './featured-menu-items.component.html',
    styleUrls: ['./featured-menu-items.component.scss']
})
export class FeaturedMenuItemsComponent implements OnInit {

    @Input() menu: any;
    mealPeriods: Array<any>;
    menuItems: Array<IPicture>;
    tooltip: any;

    constructor(
        public windowRef: WindowRef,
    ) { }

    ngOnInit() {
        if (this.menu.mealPeriods) {
            this.mapMealPeriodData();
        }
        if (this.menu.items) {
            this.mapImageData();
        }
        if (this.menu.tooltipText) {
            this.createTooltip();
        }
    }

    mapMealPeriodData() {
        this.mealPeriods = this.menu.mealPeriods.map((period) => ({
            breadcrumb: [
                {
                    label: period.title,
                    link: period.link,
                    title: period.title
                }
            ],
            breadcrumbTemplate: `{link} &#8211; ${period.priceRange}`
        }));
    }

    mapImageData() {
        this.menuItems = this.menu.items.map((item) => ({
            mobile: item.mobile,
            desktop: item.desktop,
            media: item.media,
            alt: item.alt,
            title: item.title
        }));
    }

    createTooltip() {
        this.tooltip = {
            id: 'menu-items-tooltip',
            name: 'learn-more',
            size: 's',
            position: 'top-left',
            text: this.menu.tooltipText
        };
    }
}
